/**
 * FeatureFlag model — canonical runtime flag
 */
export class FeatureFlag {
    constructor(data = {}) {
        this.flagName = data.flagName || data.name || '';
        this.isEnabled = data.isEnabled ?? data.enabled ?? false;
        this.description = data.description || '';
        this.category = data.category || null;
        this.updatedAt = data.updatedAt ? new Date(data.updatedAt) : null;
    }

    enabled() {
        return this.isEnabled === true;
    }
}

export default FeatureFlag;
